import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Header } from '../components/Header';
import { BenefitCard } from '../components/BenefitCard';
import { PrivacyModal } from '../components/PrivacyModal';
import { TermsModal } from '../components/TermsModal';
import { CategoriesModal } from '../components/CategoriesModal';
import { ApplicationModal } from '../components/ApplicationModal';
import { SparklesIcon, TrendingUpIcon, UsersIcon, GiftIcon, ZapIcon, ShieldCheckIcon, StarIcon, InstagramIcon, MailIcon } from 'lucide-react';
export function LandingPage() {
  const [isPrivacyModalOpen, setIsPrivacyModalOpen] = useState(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = useState(false);
  const [isCategoriesModalOpen, setIsCategoriesModalOpen] = useState(false);
  const [isApplicationModalOpen, setIsApplicationModalOpen] = useState(false);
  const benefits = [{
    icon: SparklesIcon,
    title: 'Descuentos Exclusivos',
    description: 'Accede a descuentos y promociones especiales en comercios afiliados según tu categoría de creador.'
  }, {
    icon: TrendingUpIcon,
    title: 'Servicios Preferenciales',
    description: 'Disfruta de atención prioritaria y servicios exclusivos en establecimientos aliados.'
  }, {
    icon: UsersIcon,
    title: 'Red de Aliados',
    description: 'Conecta con una amplia red de comercios, restaurantes, tiendas y servicios que valoran a los creadores.'
  }, {
    icon: GiftIcon,
    title: 'Invitaciones Especiales',
    description: 'Recibe invitaciones a eventos exclusivos, lanzamientos de productos y experiencias únicas.'
  }, {
    icon: ZapIcon,
    title: 'Beneficios Progresivos',
    description: 'Mientras más crece tu audiencia, mejores beneficios desbloqueas con nuestro sistema de estrellas.'
  }, {
    icon: ShieldCheckIcon,
    title: 'Uso Personal',
    description: 'Tarjeta gratuita, personal e intransferible diseñada específicamente para creadores de contenido.'
  }];
  const tiers = [{
    stars: 1,
    name: '1 Estrella',
    followers: '5K - 9.9K',
    description: 'Seguidores en Instagram o TikTok'
  }, {
    stars: 2,
    name: '2 Estrellas',
    followers: '10K - 99.9K',
    description: 'Seguidores en Instagram o TikTok'
  }, {
    stars: 3,
    name: '3 Estrellas',
    followers: '100K - 999.9K',
    description: 'Seguidores en Instagram o TikTok'
  }, {
    stars: 4,
    name: '4 Estrellas',
    followers: '1M+',
    description: 'Seguidores en Instagram o TikTok'
  }];
  return <div className="min-h-screen bg-[#0a0a0a] text-white" data-id="element-293">
      <Header onOpenApplication={() => setIsApplicationModalOpen(true)} data-id="element-294" />

      {/* Hero Section */}
      <section className="relative pt-32 pb-20 px-6 overflow-hidden" data-id="element-295">
        <div className="absolute inset-0 bg-gradient-to-b from-[#d4af37]/5 via-transparent to-transparent" data-id="element-296" />
        <div className="absolute top-20 left-1/4 w-96 h-96 bg-[#d4af37]/10 rounded-full blur-3xl" data-id="element-297" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-[#f4d03f]/10 rounded-full blur-3xl" data-id="element-298" />

        <div className="relative max-w-6xl mx-auto text-center" data-id="element-299">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} className="mb-6" data-id="element-300">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1kKZWeaKM44Vz6MBBPVhgv/elite_1.png" alt="Elite Creator Pass" className="h-32 w-32 mx-auto mb-8" data-id="element-301" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="inline-block mb-6 px-6 py-2 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] rounded-full" data-id="element-302">
            <span className="text-black font-bold text-sm" data-id="element-303">
              ✨ 100% GRATUITO • PARA CREADORES CON +5K SEGUIDORES
            </span>
          </motion.div>

          <motion.h1 initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.3
        }} className="text-6xl md:text-7xl font-bold mb-6 leading-tight" data-id="element-304">
            La Plataforma de Beneficios para{' '}
            <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-305">
              Creadores
            </span>
          </motion.h1>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} className="text-xl text-gray-400 mb-12 max-w-3xl mx-auto leading-relaxed" data-id="element-306">
            Accede a descuentos exclusivos, promociones especiales y beneficios
            en comercios afiliados. Tu tarjeta de fidelización gratuita que
            crece contigo.
          </motion.p>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 0.7
        }} className="flex flex-col sm:flex-row gap-4 justify-center items-center" data-id="element-307">
            <button onClick={() => setIsApplicationModalOpen(true)} className="px-8 py-4 bg-gradient-to-r from-[#d4af37] to-[#f4d03f] text-black font-bold rounded-full text-lg hover:shadow-2xl hover:shadow-[#d4af37]/50 transition-all duration-300 hover:scale-105" data-id="element-308">
              Quiero Inscribirme
            </button>
            <button onClick={() => setIsCategoriesModalOpen(true)} className="px-8 py-4 bg-white/5 backdrop-blur-sm border border-white/10 text-white font-semibold rounded-full text-lg hover:bg-white/10 transition-all duration-300" data-id="element-309">
              Ver Categorías
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1
        }} className="mt-16 flex items-center justify-center gap-8 text-sm text-gray-500" data-id="element-310">
            <div className="flex items-center gap-2" data-id="element-311">
              <StarIcon className="w-5 h-5 text-[#d4af37] fill-[#d4af37]" data-id="element-312" />
              <span data-id="element-313">4 Categorías</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-314">
              <StarIcon className="w-5 h-5 text-[#d4af37] fill-[#d4af37]" data-id="element-315" />
              <span data-id="element-316">100% Gratuito</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-317">
              <StarIcon className="w-5 h-5 text-[#d4af37] fill-[#d4af37]" data-id="element-318" />
              <span data-id="element-319">Beneficios Exclusivos</span>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Tiers Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-transparent via-[#d4af37]/5 to-transparent" data-id="element-320">
        <div className="max-w-7xl mx-auto" data-id="element-321">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-322">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-323">
              Sistema de{' '}
              <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-324">
                Categorías
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-325">
              Tu categoría se determina por tu número de seguidores en Instagram
              o TikTok. Mientras más creces, mejores beneficios desbloqueas.
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto" data-id="element-326">
            {tiers.map((tier, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="relative bg-gradient-to-br from-white/5 to-white/0 backdrop-blur-sm border border-white/10 rounded-2xl p-8 text-center hover:border-[#d4af37]/50 transition-all duration-300" data-id="element-327">
                <div className="flex justify-center gap-1 mb-4" data-id="element-328">
                  {[...Array(tier.stars)].map((_, i) => <StarIcon key={i} className="w-6 h-6 text-[#d4af37] fill-[#d4af37]" data-id="element-329" />)}
                </div>
                <h3 className="text-2xl font-bold text-white mb-2" data-id="element-330">
                  {tier.name}
                </h3>
                <div className="text-3xl font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent mb-2" data-id="element-331">
                  {tier.followers}
                </div>
                <p className="text-sm text-gray-400" data-id="element-332">{tier.description}</p>
              </motion.div>)}
          </div>

          <motion.p initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} viewport={{
          once: true
        }} className="text-center text-gray-500 mt-8 max-w-3xl mx-auto" data-id="element-333">
            Los beneficios específicos de cada categoría son determinados por
            cada comercio afiliado. Tu categoría se actualiza automáticamente
            según tu audiencia.
          </motion.p>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 px-6" data-id="element-334">
        <div className="max-w-7xl mx-auto" data-id="element-335">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-336">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-337">
              Beneficios en{' '}
              <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-338">
                Comercios Afiliados
              </span>
            </h2>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto" data-id="element-339">
              Disfruta de ventajas exclusivas en nuestra red de aliados
              comerciales
            </p>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-340">
            {benefits.map((benefit, index) => <BenefitCard key={index} {...benefit} index={index} data-id="element-341" />)}
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-20 px-6 bg-gradient-to-b from-transparent via-[#d4af37]/5 to-transparent" data-id="element-342">
        <div className="max-w-5xl mx-auto" data-id="element-343">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8
        }} viewport={{
          once: true
        }} className="text-center mb-16" data-id="element-344">
            <h2 className="text-4xl md:text-5xl font-bold mb-4" data-id="element-345">
              Cómo{' '}
              <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-346">
                Obtener Tu Tarjeta
              </span>
            </h2>
            <p className="text-xl text-gray-400" data-id="element-347">
              Proceso simple para creadores calificados
            </p>
          </motion.div>

          <div className="grid md:grid-cols-3 gap-8" data-id="element-348">
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} viewport={{
            once: true
          }} className="text-center" data-id="element-349">
              <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-350">
                <span className="text-3xl font-bold text-black" data-id="element-351">1</span>
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-352">Verifica Requisitos</h3>
              <p className="text-gray-400" data-id="element-353">
                Debes tener mínimo 5,000 seguidores en Instagram o TikTok para
                calificar.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} viewport={{
            once: true
          }} className="text-center" data-id="element-354">
              <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-355">
                <span className="text-3xl font-bold text-black" data-id="element-356">2</span>
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-357">
                Completa el Formulario
              </h3>
              <p className="text-gray-400" data-id="element-358">
                Llena el formulario de afiliación con tus datos y enlaces a tus
                redes sociales.
              </p>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} viewport={{
            once: true
          }} className="text-center" data-id="element-359">
              <div className="w-16 h-16 bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-2xl flex items-center justify-center mx-auto mb-6" data-id="element-360">
                <span className="text-3xl font-bold text-black" data-id="element-361">3</span>
              </div>
              <h3 className="text-2xl font-bold mb-3" data-id="element-362">Recibe Tu Tarjeta</h3>
              <p className="text-gray-400" data-id="element-363">
                Una vez aprobado, recibirás tu tarjeta digital y podrás comenzar
                a disfrutar los beneficios.
              </p>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} transition={{
          duration: 0.8,
          delay: 0.5
        }} viewport={{
          once: true
        }} className="mt-12 text-center" data-id="element-364">
            <p className="text-gray-500 text-sm max-w-2xl mx-auto" data-id="element-365">
              Tu tarjeta es personal e intransferible. La categoría se asigna
              automáticamente según tu número de seguidores y se actualiza
              conforme crece tu audiencia.
            </p>
          </motion.div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 px-6" data-id="element-366">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center bg-gradient-to-br from-[#d4af37] to-[#f4d03f] rounded-3xl p-12 md:p-16" data-id="element-367">
          <h2 className="text-4xl md:text-5xl font-bold text-black mb-6" data-id="element-368">
            ¿Tienes +5K Seguidores?
          </h2>
          <p className="text-xl text-black/80 mb-8 max-w-2xl mx-auto" data-id="element-369">
            Solicita tu Elite Creator Pass hoy y comienza a disfrutar de
            beneficios exclusivos en comercios afiliados de toda la región.
          </p>
          <button onClick={() => setIsApplicationModalOpen(true)} className="px-10 py-5 bg-black text-[#d4af37] font-bold rounded-full text-lg hover:bg-black/90 transition-all duration-300 hover:scale-105 shadow-xl" data-id="element-370">
            Quiero Inscribirme
          </button>
          <p className="mt-6 text-sm text-black/60" data-id="element-371">
            Tarjeta digital gratuita • Personal e intransferible • Beneficios
            inmediatos
          </p>
        </motion.div>
      </section>

      {/* App Download Section */}
      <section className="py-16 px-6 bg-gradient-to-b from-transparent via-[#d4af37]/5 to-transparent" data-id="element-372">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center" data-id="element-373">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-374">
            Descarga la{' '}
            <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-375">
              App Móvil
            </span>
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-376">
            Lleva tu Elite Creator Pass siempre contigo. Accede a tus
            beneficios, descubre comercios afiliados y gestiona tu tarjeta desde
            tu smartphone.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-377">
            <motion.a href="https://apps.apple.com/ec/app/elite-creator-pass/id6755869392" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block" data-id="element-378">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-8 py-4 hover:bg-white/10 transition-all duration-300 flex items-center gap-3 min-w-[200px]" data-id="element-379">
                <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor" data-id="element-380">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" data-id="element-381" />
                </svg>
                <div className="text-left" data-id="element-382">
                  <div className="text-xs text-gray-400" data-id="element-383">Descarga en</div>
                  <div className="text-lg font-semibold text-white" data-id="element-384">
                    App Store
                  </div>
                </div>
              </div>
            </motion.a>

            <motion.a href="https://play.google.com/store/apps/details?id=com.ipse.promred.elitecreatorpass" target="_blank" rel="noopener noreferrer" whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} className="inline-block" data-id="element-385">
              <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-xl px-8 py-4 hover:bg-white/10 transition-all duration-300 flex items-center gap-3 min-w-[200px]" data-id="element-386">
                <svg className="w-10 h-10" viewBox="0 0 24 24" fill="currentColor" data-id="element-387">
                  <path d="M3,20.5V3.5C3,2.91 3.34,2.39 3.84,2.15L13.69,12L3.84,21.85C3.34,21.6 3,21.09 3,20.5M16.81,15.12L6.05,21.34L14.54,12.85L16.81,15.12M20.16,10.81C20.5,11.08 20.75,11.5 20.75,12C20.75,12.5 20.53,12.9 20.18,13.18L17.89,14.5L15.39,12L17.89,9.5L20.16,10.81M6.05,2.66L16.81,8.88L14.54,11.15L6.05,2.66Z" data-id="element-388" />
                </svg>
                <div className="text-left" data-id="element-389">
                  <div className="text-xs text-gray-400" data-id="element-390">Disponible en</div>
                  <div className="text-lg font-semibold text-white" data-id="element-391">
                    Google Play
                  </div>
                </div>
              </div>
            </motion.a>
          </div>

          <p className="mt-6 text-sm text-gray-500" data-id="element-392">
            Disponible para iOS y Android • Gratis • Sin compras dentro de la
            app
          </p>
        </motion.div>
      </section>

      {/* Partnership Section */}
      <section className="py-20 px-6 border-t border-white/10" data-id="element-393">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto text-center" data-id="element-394">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-395">
            ¿Quieres que tu empresa o institución sea parte del programa de
            beneficios{' '}
            <span className="bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-396">
              Elite Creator Pass?
            </span>
          </h2>
          <p className="text-lg text-gray-400 mb-8 max-w-2xl mx-auto" data-id="element-397">
            Si eres comercio, institución o tienes un emprendimiento y quieres
            ofrecer beneficios, contáctanos.
          </p>
          <a href="mailto:aliados@elitecreatorpass.com" className="inline-block px-8 py-4 bg-white/5 backdrop-blur-sm border border-[#d4af37]/50 text-white font-semibold rounded-full text-lg hover:bg-white/10 hover:border-[#d4af37] transition-all duration-300" data-id="element-398">
            Contáctanos
          </a>
        </motion.div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/10 py-12 px-6" data-id="element-399">
        <div className="max-w-7xl mx-auto" data-id="element-400">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-401">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/1kKZWeaKM44Vz6MBBPVhgv/elite_1.png" alt="Elite Creator Pass" className="h-8 w-8" data-id="element-402" />
            <span className="text-lg font-bold bg-gradient-to-r from-[#d4af37] to-[#f4d03f] bg-clip-text text-transparent" data-id="element-403">
              ELITE CREATOR PASS
            </span>
          </div>

          <div className="text-center mb-6" data-id="element-404">
            <h3 className="text-lg font-semibold text-white mb-3" data-id="element-405">
              Contáctanos
            </h3>
            <div className="flex flex-col items-center gap-2" data-id="element-406">
              <a href="mailto:contacto@elitecreatorpass.com" className="flex items-center gap-2 text-gray-400 hover:text-[#d4af37] transition-colors" data-id="element-407">
                <MailIcon className="w-4 h-4" data-id="element-408" />
                <span data-id="element-409">contacto@elitecreatorpass.com</span>
              </a>
              <a href="https://instagram.com/EliteCreatorPass" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-gray-400 hover:text-[#d4af37] transition-colors" data-id="element-410">
                <InstagramIcon className="w-4 h-4" data-id="element-411" />
                <span data-id="element-412">@EliteCreatorPass</span>
              </a>
            </div>
          </div>

          <div className="text-center text-gray-500" data-id="element-413">
            <p className="mb-3" data-id="element-414">
              © 2026 Elite Creator Pass es una marca de la Plataforma Benefika
              de TicketMaestro. Todos los derechos reservados.
            </p>
            <div className="flex items-center justify-center gap-4 flex-wrap" data-id="element-415">
              <button onClick={() => setIsPrivacyModalOpen(true)} className="text-gray-400 hover:text-[#d4af37] transition-colors underline" data-id="element-416">
                Política de Privacidad y Protección de Datos
              </button>
              <span className="text-gray-600" data-id="element-417">•</span>
              <button onClick={() => setIsTermsModalOpen(true)} className="text-gray-400 hover:text-[#d4af37] transition-colors underline" data-id="element-418">
                Términos y Condiciones de Uso
              </button>
            </div>
          </div>
        </div>
      </footer>

      <PrivacyModal isOpen={isPrivacyModalOpen} onClose={() => setIsPrivacyModalOpen(false)} data-id="element-419" />
      <TermsModal isOpen={isTermsModalOpen} onClose={() => setIsTermsModalOpen(false)} data-id="element-420" />
      <CategoriesModal isOpen={isCategoriesModalOpen} onClose={() => setIsCategoriesModalOpen(false)} data-id="element-421" />
      <ApplicationModal isOpen={isApplicationModalOpen} onClose={() => setIsApplicationModalOpen(false)} onOpenTerms={() => {
      setIsTermsModalOpen(true);
    }} onOpenPrivacy={() => {
      setIsPrivacyModalOpen(true);
    }} data-id="element-422" />
    </div>;
}